import * as settings from '../state/preferences';

export type headers = {
  'Content-Type': string;
  authorization?: string;
  organization?: string;
  store?: string;
  kitchenDisplay?: string;
};

export function getTokenFromHeader(headers: headers): string {
  return headers?.authorization?.replace('Bearer ', '') || '';
}

export async function getHeaders() {
  const session = await settings.getSession();
  const headers: headers = {
    'Content-Type': 'application/json',
  };
  if (session?.token) {
    headers['authorization'] = session.token;
  }
  if (session?.currentOrganization?.id) {
    headers['organization'] = session.currentOrganization.id;
  }
  if (session?.currentStore?.id) {
    headers['store'] = session.currentStore.id;
  }
  if (session?.kitchenDisplay?.id) {
    headers['kitchenDisplay'] = session.kitchenDisplay.id;
  }
  return headers;
}
